module.exports = __webpack_public_path__ + "static/img/demo-img.78f18a7c.jpg";